import React, { useEffect, useState } from "react";
import { StepContent } from "../Components";
import CircleCheck from "../../../../assets/CheckCircle.svg";
import { Button } from "../../../Actions";
import { useWizard } from "react-use-wizard";
import { makeInvites } from "../../../../utils/api/generateInvites";
import { useUserContext } from "../../../../contexts/User";
import { useAccount, useReadContract } from "wagmi";
import { coinageRead } from "../../../../useCoinageContract";

const Success: React.FC = () => {
  const { nextStep } = useWizard();
  const [loading, setIsLoading] = useState(true);
  const { user } = useUserContext();

  const { address } = useAccount();
  const { data: networkCount } = useReadContract({
    ...coinageRead,
    functionName: "balanceOf",
    query: {
      enabled: !!address
    },
    args: [address, 1]
  });

  useEffect(() => {
    const checkIfOwnsTokenAndMakeInvites = async () => {
      if (!user?.id || !networkCount) return;
      const ownsToken = Number(networkCount?.toString()) > 0;
      if (ownsToken && user?.id) {
        await makeInvites({ id: user?.id });
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    };
    // check if user owns a network token
    // if they own it, we call the `make-invites`
    // make invites will handle logic if they have already minted or not
    checkIfOwnsTokenAndMakeInvites();
  }, [user?.id, networkCount]);
  return (
    <>
      <CircleCheck className="text-coinage-teal" width="50"></CircleCheck>
      <StepContent
        title="Success!"
        description={
          <span className="text-coinage-black">
            <b className="text-coinage-orange">Welcome to Coinage Network.</b>{" "}
            We’re so happy you’re building this with us. You may now see the
            results of your trust experiment and claim any invitations you’ve
            earned.
          </span>
        }>
        <Button
          onClick={nextStep}
          analyticsProperty="seeResults"
          modifier="primary"
          loading={loading}>
          See Results
        </Button>
      </StepContent>
    </>
  );
};

export default Success;
